import '../MetasGerais/MetasGerais.css'
import { useEffect, useRef, useState } from 'react';
import { logout } from '../../auth';
import { get, post } from '../../services/api';
import imagemExemplo from '../../assets/img/imagemExemploCsvServicosExtra.png';
import AdminSection from "../AdminSection/AdminSection";
import DownloadIcon from '@mui/icons-material/Download';

export default function MetasServicoExtra({ setNotifier }) {

    const [ valorBase, setValorBase ] = useState('');
    const [ valorBaseCSVFileName, setValorBaseCSVFileName ] = useState(undefined);
    const [ valorBasePadrao, setValorBasePadrao ] = useState(0);
    const valorBaseCSVRef = useRef(undefined);
    const valorBasePadraoRef = useRef(undefined);

    function handleRefresh(e, type = 'all') {
        e.preventDefault();

        refreshInputs(type);
    }

    function isThirdStagePopuled() {
        const valorBaseNumber = Number(valorBase.replaceAll('.', '').replace(',', '.'))

        return  (!isNaN(valorBaseNumber) && valorBaseNumber != 0) ||
            valorBaseCSVFileName !== undefined || 
                valorBasePadrao !== 0;  
    }

    function refreshInputs(type = 'all') {
        setValorBase('');
        setValorBaseCSVFileName(undefined);
        if(valorBaseCSVRef.current?.value != undefined) valorBaseCSVRef.current.value = null;
        setValorBasePadrao(0);
        if(valorBasePadraoRef.current?.value != undefined) valorBasePadraoRef.current.checked = false;
    }

    async function handleValorBaseSubmit(event){
        event.preventDefault();

        const idUsuarioAtual = localStorage.getItem("idusuario");
        const authToken = localStorage.getItem("adminToken");

        if(typeof idUsuarioAtual === 'undefined') {
            logout();
        } else{
            const formData = new FormData(event.target);

            formData.append('idusuario', idUsuarioAtual);

            const { response } = await post('/admin/uploadMetasExtra/metas-servico-extra', formData, authToken, { 
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            
            if(response?.status >= 400){
                setNotifier(false, response.data)
            }
            else{
                setNotifier(true, 'Enviado com sucesso')
            }
        }
    }

    function baixarExemploCSV() {
        const csvData = [
            ['Cod. Filial', 'Mes', 'Ano', 'Meta', 'Meta ideal', 'Meta desafio', 'Meta desafio diaria', 'Meta diaria vendedor', 'Meta garantia', 
                'Meta garantia diaria']
        ];

        const csvContent = csvData.map(e => e.join(";")).join("\n");
        const blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'exemploMetasServicosExtra.csv';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    return <>


    <AdminSection
        etapa={1} titulo={'Importar metas serviços Extranet'}
        acoes={<>
            <button type="button" className='download-btn' onClick={baixarExemploCSV}> <DownloadIcon style={{width: '25px', height: '25px', marginRight: '10px'}}/> Exportar modelo</button>
        </>}
        >
        <div className="texto-csv" style={{paddingTop: "30px"}}>
            <span className="bold-text">
              Exemplo a ser seguido:      
            </span>
          </div>
        <div className='imagemExemplo'>
            <img src={imagemExemplo} alt="Exemplo" /><br></br>
        </div>  

        <form onSubmit={handleValorBaseSubmit}>
            <div className='p-8' style={{paddingBottom: "16px"}}>
                <div className="texto-csv">
                    <span className="bold-text">Importe seu arquivo clicando no botão abaixo</span>
                    <div className="normal-text">O arquivo deve ser em formato CSV. O separador de colunas será identificado automaticamente.</div>
                     <div className="normal-text">Ao abrir/salvar o arquivo CSV no LibreOffice, <span className='bold-text' style={{ fontSize: '0.85rem' }}>selecione ponto e vírgula (;) </span>{' '} como separador de colunas. </div>
                      <div className="bold-text" style={{ fontSize: '0.85rem' }}>
  *Somente é possível importar dados referentes ao mês atual ou ao mês anterior.
</div>
                </div>
                <div className='importar-csv'>
                    <label htmlFor="valorBaseCSV" className= {`btn-label {valorBase != '' || valorBasePadrao !== 0 ? 'disabled' : ''}`}>Importar CSV</label>
                        <input type="file" accept='.csv' ref={valorBaseCSVRef} name='valorBaseCSV' id="valorBaseCSV" onChange={(e) => {
                            const uploadedFile = e.target.files[0];
                            if (uploadedFile) {
                                setValorBaseCSVFileName(uploadedFile.name);
                            }
                        }} disabled={valorBase != '' || valorBasePadrao !== 0}/>
                    <label className='muda-nome'>{valorBaseCSVFileName === undefined ? '' : valorBaseCSVFileName}</label>
                </div>
            </div>
            <div className='animal-valorBase-buttons' style={{textAlign: "center", padding: "0px"}}>
                        <button 
                            className='animal-refresh-btn' 
                            onClick={(e) => handleRefresh(e, 'metaBase')}>Cancelar
                        </button>
            </div>
            <div className="button-container" style={{justifyContent: 'flex-end'}}>
                <button className='animal-save-btn' disabled={!isThirdStagePopuled()}>Enviar CSV</button>
            </div>
        </form>     
    </AdminSection>
</>
}
